import { type JSONObject } from '@imago/api-client'
import { type DocBlock } from './_Doc.ts'
import { type EMRKindID, type EMRTypeID } from './_EMR.ts'
import { type ProductID, type ServiceID } from './ServiceProduct.ts'

export const ServicesRequest_ID = 'imago.user-services-request' as EMRTypeID & EMRKindID

export interface UserServicesRequestContent {
	services: Set<ProductID & ServiceID>
}

export interface UserServicesRequestContentJSON extends JSONObject {
	services: (ProductID & ServiceID)[]
}

export function deserializeUserServicesRequestContent(request: UserServicesRequestContentJSON): UserServicesRequestContent {
	return {
		services: new Set(request.services),
	}
}

export function serializeUserServicesRequestContent(request: UserServicesRequestContent | undefined | null): UserServicesRequestContentJSON | undefined | null {
	return !request ? request : {
		services: [...request.services],
	}
}

export function docifyUserServicesRequest(request: UserServicesRequestContent): DocBlock[] {
	return [
		{ class: 'TITLE', text: "User services request" },
		...[...request.services].map(service => ({ class: 'NORMAL_TEXT', text: `- ${service}` } satisfies DocBlock)),
	]
}
